<template>
  <div :class="['pretty p-smooth p-round', hasSvg ? 'p-svg' : 'p-default']">
    <input
      type="radio"
      v-bind="$attrs"
      v-bind:value="value"
      v-bind:checked="value === checked"
      v-on="inputListeners"
    />
    <div class="state p-primary space-x-1">
      <BaseIcon v-if="hasSvg" class="svg" :icon="$attrs.svg" />
      <label>
        <slot />
        {{ label }}
      </label>
    </div>
  </div>
</template>

<script>
import BaseIcon from './_base-icon.vue'

export default {
  components: {
    BaseIcon,
  },
  inheritAttrs: false,
  props: {
    value: {},
    checked: {},
  },
  model: {
    prop: 'checked',
    event: 'input',
  },
  computed: {
    hasLabel() {
      return typeof this.$attrs.label !== 'undefined'
    },
    label() {
      return typeof this.$attrs.label === 'undefined'
        ? ''
        : this.$t(`mygwf.components.Label.${this.$attrs.label}`)
    },
    hasSvg() {
      return typeof this.$attrs.svg !== 'undefined'
    },
    inputListeners: function () {
      var vm = this
      return Object.assign({}, this.$listeners, {
        change: function (event) {
          vm.$emit('input', event.target.value)
        },
      })
    },
  },
}
</script>
